import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78208b06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MItemDaListaDeProfissionais",
  "data-testid": "MItemDaListaDeProfissionais"
}
const _hoisted_2 = { class: "MItemDaListaDeProfissionais__NomeEmail" }
const _hoisted_3 = { "data-testid": "MItemDaListaDeProfissionais__ProfissionalNome" }
const _hoisted_4 = { "data-testid": "MItemDaListaDeProfissionais__ProfissionalEmail" }

import Avatar from "primevue/avatar"
  import { computed } from "vue"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { EntidadeGenerica } from "@/types/gerais"

  interface Props {
    profissional: EntidadeGenerica
    avatarGrande?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MItemDaListaDeProfissionais',
  props: {
    profissional: null,
    avatarGrande: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    profissional: EntidadeGenerica
    avatarGrande?: boolean
  }

  const { pegarIniciais } = usarFuncoesStrings()

  

  const nomeProfissional = computed(() => {
    return props.profissional.nome
  })

  const emailProfissional = computed(() => {
    return props.profissional.email
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Avatar), {
      class: _normalizeClass(["MItemDaListaDeProfissionais__ProfissionalFoto", 
        __props.avatarGrande &&
        'MItemDaListaDeProfissionais__ProfissionalFoto--AvatarGrande'
      ]),
      "data-testid": "MItemDaListaDeProfissionais__ProfissionalFoto",
      label: _unref(pegarIniciais)(_unref(nomeProfissional)),
      shape: "circle",
      size: "normal",
      style: { 'background-color': '#00707d', color: 'white' }
    }, null, 8, ["class", "label"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(nomeProfissional)), 1),
      _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(emailProfissional)), 1)
    ])
  ]))
}
}

})